import React, { useState, useEffect } from 'react';
import amaxLogo from "../../images/amaxLogoWhite.png";
import arrowNext from "../../images/arrowNext.svg";
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import API_URL from '../../api/API';


export const AthleteStep2 = () => {


  const [email,setEmail] = useState('');
  const [password,setPassword] = useState('');
  const [error, setError] = useState(null);
  const [msg, setMsg] = useState(null);
  const [loading, setLoading] = useState(false);


  const navigate = useNavigate();

   
  useEffect(() => {
    // Restore data from sessionStorage
    const email_ = sessionStorage.getItem('email');
    const password_ = sessionStorage.getItem('password');

    if (email_) setEmail(email_);
    if (password_) setPassword(password_);
  }, []);


  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!email || !password) {
      setError('Please enter all the details!');
      setMsg(null);
      return;
    }

    setError(null);
    setMsg(null);
    setLoading(true);

    try {
      const response = await fetch(API_URL.POST_CHECK_ATHLETE_EMAIL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({email}),
      });

      const data = await response.json();
      setLoading(false);

      if (response.ok) {
        if(data.exists){
          setError(data.message);
          sessionStorage.setItem("email",email);
          sessionStorage.setItem("password",password);
        }
        else{
             // Success: Navigate to the next step
             sessionStorage.setItem("email",email);
             sessionStorage.setItem("password",password);
            navigate('/athlete/register/step3');
            //setMsg("Success to proceed");
        }
     
      } else {
        // Display error returned by the server
        setError(data.error || 'An error occurred. Please try again.');
      }
    } catch (err) {
      setLoading(false);
      setError('Failed to connect to the server. Please try again.');
    }
  };



    return (
      <div className="p-[20px] bg-white h-dvh overflow-hidden">
        <div className="w-full max-w-2xl mx-auto h-full flex flex-col justify-between items-center gap-[160px] overflow-y-auto">
          <Link to="/" className="size-[96px] lg:size-[166px]">
            <img src={amaxLogo} alt="logo" className="object-contain" />
          </Link>
          <div className="flex flex-col gap-12 w-full">
            <div className="flex flex-col gap-4">
              <h1 className="text-black text-3xl xs:text-4xl leading-tight uppercase">
                LOGIN INFO
              </h1>
              <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                <input
                  type="email"
                  className="border border-grayish rounded-2xl bg-transparent text-black text-base xs:text-lg font-light leading-none p-3 xs:p-4 placeholder:text-grayish placeholder:uppercase"
                  placeholder="Email*"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <input
                  type="password"
                  className="border border-grayish rounded-2xl bg-transparent text-black text-base xs:text-lg font-light leading-none p-3 xs:p-4 placeholder:text-grayish placeholder:uppercase"
                  placeholder="Password*"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />

              {/* Display Loading Indicator */}
              {loading && (
                <p className="text-yellow-500 text-sm mt-2">
                  Processing request please wait...
                </p>
              )}


                   {/* Display Error Message */}
              {error && (
                <p className="text-red-500 text-sm mt-2">
                  {error}
                </p>
              )}

              {/* Display Success Message */}
              {msg && (
                <p className="text-green-500 text-sm mt-2">
                  {msg}
                </p>
              )}

              <button
                type="submit"
                className="bg-black size-12 xs:size-14 rounded-full flex justify-center items-center hover:bg-black/70 transition-all duration-300 ml-auto mt-[10px]"
              >
                <img src={arrowNext} alt="arrow" className="object-contain invert max-w-5 xs:max-w-6" />
              </button>
              </form>
            </div>
           
          </div>
        </div>
      </div>
    );
  };
  